import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getMovieSearch } from "../services/movieApi";
import MovieList from "../components/MovieList";

import "./SearchResultsPage.scss";

const SearchResultsPage = () => {
    const [searchedMovies, setSearchedMovies] = useState(null);
    const [loadingSearchedMovies, setLoadingSearchedMovies] = useState(false);
    const { searchTerm, pageNumber } = useParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        const fetchSearchedMovies = async () => {
            try {
                setLoadingSearchedMovies(true);
                const data = await getMovieSearch(searchTerm, pageNumber);
                setSearchedMovies(data.results);
                setCurrentPage(data.page);
                setTotalPages(data.total_pages);
                setLoadingSearchedMovies(false);
            } catch (error) {
                console.error("Failed to fetch searched movies: ", error);
            }
        };

        fetchSearchedMovies();
    }, [searchTerm, pageNumber]);

    let prevPage = currentPage - 1;
    let nextPage = currentPage + 1;

    const handleNextPageReq = () => {
        if (nextPage <= totalPages) {
            pageReq(nextPage);
        }
    };

    const handlePrevPageReq = () => {
        if (prevPage > 0) {
            pageReq(prevPage);
        }
    };

    const pageReq = async (page) => {
        try {
            navigate(`/movies/search/${searchTerm}/page/${page}`);
        } catch (error) {
            console.error("Error changing page: ", error);
        }
    };

    return (
        <div className="search-results-container layout">
            <h1>
                Search results for <span>{searchTerm}</span>
            </h1>
            {loadingSearchedMovies ? (
                <p>Loading...</p>
            ) : // Add a conditional check for searchedMovies
            searchedMovies ? (
                <>
                    <MovieList movies={searchedMovies} />
                    <div className="pagination">
                        <button
                            className={`prev ${
                                prevPage === 0 ? "noclick" : ""
                            }`}
                            onClick={handlePrevPageReq}
                        >
                            Prev
                        </button>
                        <button className="pagination-button">
                            {currentPage}
                        </button>
                        <button
                            className={`next ${
                                nextPage === totalPages + 1 ? "noclick" : ""
                            }`}
                            onClick={handleNextPageReq}
                        >
                            Next
                        </button>
                    </div>
                </>
            ) : (
                <p>No movies found</p>
            )}
        </div>
    );
};

export default SearchResultsPage;
